import React from 'react';
import {SkeletonLoader} from './index';
import {toolTip} from '../assets/images/images';

export const OverviewCards = ({
  cardData = [],
  overviewLoading,
  className,
  innerClassName,
  loaderWidth,
  formatValue,
}) => {
  const location = window.location.pathname;
  const isLookupRoute = location.includes('easy-lookup');
  const isBusinessRoute = location.includes('business');
  const tooltipText = isBusinessRoute ? '' : 'User';

  return (
    <div
      className={
        className ||
        'flex items-center justify-center xl:justify-between xl:gap-0 gap-4 mt-4 flex-wrap mb-12'
      }
    >
      {cardData &&
        cardData?.map(({title, value, count, isNegative}) => (
          <div
            key={title}
            className={`${innerClassName} bg-white border py-4 px-6 border-[#E4E7EC] shadow-cards relative flex-wrap rounded-xl flex items-center gap-2 lg:flex-col lg:items-start xl:flex-row xl:items-center`}
          >
            <div className="flex flex-col flex-wrap gap-4">
              <p className="text-sm text-[#667185] font-medium">{title}</p>

              {overviewLoading ? (
                <SkeletonLoader
                  style={{
                    width: loaderWidth || 150,
                    height: 25,
                    marginBottom: 10,
                  }}
                />
              ) : (
                <h1
                  className={`text-[32px] font-semibold ${
                    isNegative ? 'text-status-404' : 'text-[#1D2739]'
                  }`}
                >
                  {formatValue ? formatValue(value) : value}
                </h1>
              )}
              {title === 'In Progress' && (
                <div className="absolute top-[14px] right-[24px] group">
                  <img src={toolTip} alt="tooltip" className="cursor-pointer" />
                  <div className="hidden group-hover:block w-[250px] bg-grey-50 h-[55px] absolute bottom-full text-center top-[25px] right-0  text-[#5C688E] text-[12px] rounded p-2">
                    This is a combination of Pending and Ongoing Verifications
                  </div>
                </div>
              )}
              {title === 'Successful' && isLookupRoute && (
                <div className="absolute top-[14px] right-[24px] group">
                  <img src={toolTip} alt="tooltip" className="cursor-pointer" />
                  <div className="hidden group-hover:block w-[350px]  bg-grey-50 h-fit absolute bottom-full text-start top-[25px] right-0  text-[#5C688E] text-[12px] rounded p-2 ">
                    This is a combination of{' '}
                    <span className="font-bold text-success">
                      {tooltipText} Found
                    </span>{' '}
                    and{' '}
                    <span className="font-bold text-dojahBlue">
                      {tooltipText} Not Found
                    </span>
                    .
                  </div>
                </div>
              )}
              {count && (
                <p className="font-medium text-xs absolute right-[16px] bottom-[8px]">
                  Count: <span>{count}</span>
                </p>
              )}
            </div>
          </div>
        ))}
    </div>
  );
};
